
/**
 * Functions for generating metrics content
 */

export function generateMetricsContent(
  babyName: string, 
  height?: string, 
  weight?: string, 
  diaperChanges?: string, 
  milkIntake?: string
): string {
  const metrics = [];
  
  if (height) {
    metrics.push(`${babyName} measures ${height} tall`);
  }
  
  if (weight) {
    metrics.push(`weighs ${weight}`);
  }
  
  if (diaperChanges) {
    const diaperPhrases = [
      `We changed ${babyName}'s diaper ${diaperChanges} today`,
      `There were ${diaperChanges} diaper changes for ${babyName} today`,
      `${babyName} needed ${diaperChanges} diaper changes throughout the day`,
      `We went through ${diaperChanges} diapers with ${babyName} over the course of the day`,
      `${babyName} had ${diaperChanges} diaper changes today, each a little adventure in itself`,
      `I've become an expert at quick changes, with ${diaperChanges} diaper swaps for ${babyName} today`,
      `${babyName} kept me busy with ${diaperChanges} diaper changes from morning to night`
    ];
    metrics.push(diaperPhrases[Math.floor(Math.random() * diaperPhrases.length)]);
  }
  
  if (milkIntake) {
    const milkPhrases = [
      `${babyName} drank ${milkIntake} of milk today`,
      `${babyName}'s milk intake was ${milkIntake} for the day`,
      `We fed ${babyName} ${milkIntake} of milk throughout the day`,
      `${babyName} happily consumed ${milkIntake} of milk today, growing stronger with each feeding`,
      `${babyName} took ${milkIntake} of milk today, showing a healthy appetite`,
      `Feeding went well today with ${babyName} drinking ${milkIntake} of milk in total`,
      `${babyName}'s nutrition for the day included ${milkIntake} of milk spread across several feedings`
    ];
    metrics.push(milkPhrases[Math.floor(Math.random() * milkPhrases.length)]);
  }
  
  if (metrics.length === 0) {
    return '';
  }
  
  if (metrics.length === 1) {
    return `\n\n${metrics[0]}.`;
  }
  
  const metricsIntros = [
    `Today's health check:`,
    `Growth and health notes:`,
    `Tracking ${babyName}'s progress:`,
    `Daily metrics:`,
    `Health snapshot today:`
  ];
  
  let result = `\n\n${metricsIntros[Math.floor(Math.random() * metricsIntros.length)]} `;
  
  if (height && weight) {
    result += `${babyName} measures ${height} tall and weighs ${weight}`;
    metrics.splice(0, 2);
    
    if (metrics.length > 0) {
      result += `. ${metrics.join(". ")}.`;
    } else {
      result += ".";
    }
  } else {
    result += `${metrics.join(". ")}.`;
  }
  
  return result;
}
